import { useAuth } from '../context/AuthContext';
import Button from './Button';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

function Navbar() {
  const { t } = useTranslation();
  const { isAuthenticated, logout, passwordChangeRequired } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogoClick = (e) => {
    if (passwordChangeRequired) {
      e.preventDefault();
    }
  };

  const handleLogout = async () => {
    if (isLoggingOut) return;
    
    setIsLoggingOut(true);
    try {
      await logout();
    } catch (error) {
      console.error('Error during logout:', error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div id="navigation" className="flex h-fit justify-between px-5 py-3 z-10 w-full">
      <a href="/home" onClick={handleLogoClick}>
        <img className="h-12 w-auto" id="logo" alt="Logo" />
      </a>
      <div className="flex items-center gap-2">
        {isAuthenticated && (
          <Button 
            variant="logout" 
            label={isLoggingOut ? t('navbar.loggingOut') : t('navbar.logout')} 
            onClick={handleLogout}
            disabled={isLoggingOut}
          />
        )}
        <Button variant="lang" label={t('navbar.buttonLabel')} />
      </div>
    </div>
  );
}

export default Navbar;